import React from 'react';
import Icon from './Icon';

const RoadIcon = (props) => (
    <Icon {...props}>
        <path
            d="M5 2V22M19 2V22M12 3V6.5M12 10.5V14M12 18V21.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default RoadIcon;
